import styled from "styled-components"
// import {
//     COLOR,
//     FONT
// } from 'assets'

export const BoxShowStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
    .theme_standard {
        .group_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
            :last-child {
                margin-bottom: 0px;
            }
        }
    }
`